import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MailCheckout } from 'src/app/models/mail-checkout';
import { ModalConfig } from 'src/app/models/modal.config';
import { PermiteReenvioSolicitacao } from 'src/app/models/PermiteReenvioSolicitacao.model';
import { AlertService } from 'src/app/services/alert.service';
import { PreCheckoutService } from 'src/app/services/pre-checkout.service';
import { ModalComponent } from 'src/app/shared/modal/modal.component';
import { SpinnerService } from 'src/app/shared/spinner/spinner.service';
import { Utilitarios } from 'src/app/shared/utilitarios';
import { PreCheckoutQuery } from 'src/app/state/pre-checkout.query';
import { StateService } from 'src/app/state/state.service';
import { PreCheckoutViagemService, Values } from '../pre-checkout-viagem.service';

const COLETA_INBOUND = 'COLETA INBOUND';

@Component({
  selector: 'app-pre-checkout-viagem-com-rota',
  templateUrl: './pre-checkout-viagem-com-rota.component.html',
  styleUrls: ['./pre-checkout-viagem-com-rota.component.css']
})
export class PreCheckoutViagemComRotaComponent implements OnInit {

  cdsOrigem: Array<any> = [];
  itemSelected: any = {id:0, name:""};
  translation: any;
  tentativa: number = 0;
  usuarioBloqueado: boolean = false;
  rota: string = null;
  cpf: string = null;
  nome: string;
  celular: string;
  sendMail: boolean = false;
  recipientMail: string = null;
  sm: string = null;
  tipoTransporte: string = null;
  scheduler: any;
  ocultaField: boolean = false;
  mailCheckout: MailCheckout = new MailCheckout();
  
  modalConfig: ModalConfig = { 
    modalTitle: ""
  };
  @ViewChild('modalCadastroViagem') private modalCadastroViagemComponent: ModalComponent
  @ViewChild('modalAtualizacaoViagem') private modalAtualizacaoViagemComponent: ModalComponent

  constructor(
    private preCheckoutService: PreCheckoutService,
    private translate: TranslateService,
    private preCheckoutQuery: PreCheckoutQuery,
    private stateService: StateService,
    private alertService: AlertService,
    private router: Router,
    private viagemService: PreCheckoutViagemService,
    private spinnerService: SpinnerService
  ) { }

  openModalCadastroViagem() {
    this.modalConfig.modalTitle = "Aviso";
    this.modalConfig.closeButtonLabel = "Sim";
    this.modalConfig.dismissButtonLabel = "Não";
    this.modalConfig.shouldClose = this.onSalvar.bind(this);
    this.modalConfig.onDismiss = this.onCancelar.bind(this);

    return this.modalCadastroViagemComponent.open();
  }

  openModalAtualizacaoViagem(){
    this.modalConfig.modalTitle = "Aviso";
    this.modalConfig.closeButtonLabel = "Sim";
    this.modalConfig.dismissButtonLabel = "Não";
    this.modalConfig.shouldClose = this.onSalvarAtualizacao.bind(this);
    this.modalConfig.onDismiss = this.onCancelar.bind(this);

    return this.modalAtualizacaoViagemComponent.open();
  }

  onSalvar() {
    this.viagemService.setValue(new Values(this.itemSelected.id, this.rota));
    this.stateService.updateRoute(this.rota);
    this.stateService.updateOriginCd(this.itemSelected.name);
    this.sendMail = true;
    return true;
  }

  onCancelar(){
    this.alertService.alertWarning("Não foi localizado nenhuma SM para o CPF, Rota e CD de origem informado, tente novamente!", null);
    this.tentativasLimiteBloqueio(function(){
      this.bloquearMotorista();
      this.usuarioBloqueado = true;
    }.bind(this));
  }

  loadWait(){
    setTimeout(function(){
      this.spinnerService.requestStarted("ampulheta.gif", "Aguarde...", true, "Já contactado, clique aqui!", true);
    }.bind(this), 500);
  }

  async onSalvarAtualizacao() {
    this.updateCPFViagem();

    return true;
  }

  getInfoMail(){
    switch(this.tipoTransporte){
      case COLETA_INBOUND:
        this.recipientMail = "coletas.inbound@multivarejogpa.com;vinicius.pereira2@gpabr.com";
        break;
      default:
        this.recipientMail = "gerenciamentologistico@gpabr.com;vinicius.pereira2@gpabr.com";
    }
  }

  getBodyMail(): string{
    let html = "<!DOCTYPE html>";
    html += "<html>";
    html += "<head>";
    html += "<title>Page Title</title>";
    html += "</head>";
    html += "<body style='background-color: #E4E4E4;'>";
    html += "<div style='position: absolute; margin: auto; top: 0; right: 0; bottom: 0; left: 0; width: 400px; height: auto; background-color: #ccc; border-radius: 3px; padding: 10px;'>";
    html += "<p><center><strong>&lt;Solicitação encaminhada pelo motorista através do aplicativo Pré-checkout, e-mail automático não responda&gt;</center></strong></p>";
    html += "<br/>";
    html += "<p>Solicitação de substituição de CPF para essa viagem:</p>";
    html += "<p><strong>Rota</strong>: "+this.rota+" </p>";
    html += "<p><strong>SM</strong>: "+this.sm+" </p>";
    html += "<p><strong>CPF</strong>: "+this.cpf+" </p>";
    html += "<p><strong>Nome</strong>: "+this.nome+" </p>";
    html += "<p><strong>Celular contato</strong>: "+this.celular+" </p>";
    html += "<p><strong>CD Orig.</strong>: "+this.itemSelected.name+" </p>";
    html += "</div>";
    html += "</body>";
    html += "</html>";

    return html;
  }

  async cadastraEnvioSolicitacao(): Promise<number>{
    this.mailCheckout.cpf = this.cpf;
    this.mailCheckout.cd_origem = this.itemSelected.id?.toString();
    this.mailCheckout.rota = this.rota;
    this.mailCheckout.sm = this.sm?.toString();
    this.mailCheckout.tipo = 2;

    return await this.preCheckoutService.CreateMailCheckout(this.mailCheckout).toPromise();
  }

  async permiteReenvioSolicitacao(): Promise<PermiteReenvioSolicitacao>{
    this.mailCheckout.cpf = this.cpf;
    this.mailCheckout.cd_origem = this.itemSelected.id?.toString();
    this.mailCheckout.rota = this.rota;
    this.mailCheckout.sm = this.sm?.toString();
    this.mailCheckout.tipo = 2;

    return await this.preCheckoutService.PermiteReenvioSolicitacao(this.mailCheckout).toPromise();
  }

  updateCPFViagem(){
    this.preCheckoutService.updateCpf(parseInt(this.sm),this.cpf)
    .subscribe(
      (result) => {
        if(result.success){
          this.viagemService.setValue(new Values(this.itemSelected.id, this.rota));
          this.stateService.updateRoute(this.rota);
          this.stateService.updateOriginCd(this.itemSelected.name);
          this.ocultaField = true;
          this.alertService.alertSuccess("Alteração de CPF realizada com sucesso!", null);
        }
        else{
          this.alertService.alertWarning(result.message, null);
        }
      },
      (err) => {
        this.internalError("Ocorreu um erro ao tentar atualizar CPF na SM, tente novamente!");
      }
    );
  }

  sendMailCPF(){
    this.getInfoMail();
    
    let title = "[Pré-Checkout] - CPF: "+this.cpf+" - Solicitação de Alteração do CPF";
    let recipient = this.recipientMail;
    let body = this.getBodyMail();
    
    this.preCheckoutService.sendMail(title, body, recipient)
    .subscribe(
      (result) => {
        if(result)
        {
          this.loadWait();
          this.cadastraEnvioSolicitacao();
          this.viagemService.setValue(new Values(this.itemSelected.id, this.rota));
          this.stateService.updateRoute(this.rota);
          this.stateService.updateOriginCd(this.itemSelected.name);
          this.ocultaField = true;
          this.alertService.alertSuccess("Solicitação de alteração de CPF enviada com sucesso!", null);
          this.schedulerExisteSM();
        }
      },
      (err) => {
        this.internalError("Ocorreu um erro ao tentar enviar e-mail de solicitação de alteração de CPF, tente novamente!");
      }
    );
  }

  //Verifica se existe SM cadastrada a cada 5 minutos
  schedulerExisteSM(){
    console.log("setInterval: Consultando SM a cada 5 minutos");
    this.scheduler = setInterval(() => {
      this.existeSM(null, null, function(){
        this.stateService.updateSm(this.sm);
        this.alertService.alertSuccess("CPF alterado com sucesso, clique em PROSSEGUIR!", null);
        this.spinnerService.requestEnded();
        if (this.scheduler) {
          clearInterval(this.scheduler);
        }
      }.bind(this));
    }, Utilitarios.WAIT_TIME);
  }

  bloquearMotorista(){
    this.preCheckoutService.bloquearMotorista(this.cpf)
      .subscribe(
        (result) => {
          let message = "Você excedeu o limite máximo de 3 tentativas!\n";
            message+="Pré-checkout reprovado!";
          this.alertService.alertWarning(message, null);
        },
        (err) => {
          this.internalError(null);
        }
      );
  }

  tentativasLimiteBloqueio(callBack: any)
  {
    this.tentativa = Utilitarios.tentativasLimiteBloqueio(this.tentativa, callBack);
  }

  existeSM(callBack1: any, callBack2: any, callBack3: any){
    this.preCheckoutService.getViagemByCpfOrigem(this.cpf, this.itemSelected.id, this.rota)
    .subscribe(
      (result) => {
        if(!result.cpf){
          if(callBack1)
            callBack1();
        }
        else if(result.data_inicio){
          this.alertService.alertWarning("Viagem em trânsito, não e permitido realizar o pré-checkout, favor contactar o Glog!", null);
          this.tentativasLimiteBloqueio(function(){
            this.bloquearMotorista();
            this.usuarioBloqueado = true;
          }.bind(this));
        }
        else if(result.cpf && result.cpf != this.cpf){
          if(callBack2)
            callBack2(result);
        }
        else{
          if(callBack3)
            callBack3(result);
        }
      },
      (err) => {
        this.internalError("Ocorreu um erro ao tentar recuperar viagem, tente novamente!");
      }
    );
  }

  prosseguir(){
    if(this.itemSelected.id && this.rota)
    {
      this.existeSM(function(){
        this.openModalCadastroViagem();
      }.bind(this), function(obj){
        this.sm = obj.sm;
        this.tipoTransporte = obj.tipo_transporte;
        this.openModalAtualizacaoViagem();
      }.bind(this), function(obj){
        //Limpa alert
        this.alertService.limpaAlertMessage();
        this.stateService.updateSm(obj.sm);
        this.stateService.updateRoute(this.rota);
        this.stateService.updateOriginCd(this.itemSelected.name);
        this.viagemService.setValue(new Values(this.itemSelected.id, this.rota));
        //Marca como concluído o estágio de viagem
        this.stateService.updateStageViagem(true);

        Utilitarios.NEXT_LEVEL="veiculo";
        this.router.navigate(['/veiculo']);
      }.bind(this));
    }
  }

  populaCdsOrigem(descricao: string = null){
    this.preCheckoutService.getCds(true, descricao)
    .subscribe(
      (result) => {
        if(result)
        {
          this.cdsOrigem = [];
          
          for(let cd of result.content)
          {
            let obj = {id:cd.id,name:cd.descricao};
            this.cdsOrigem.push(obj);
          }
        }
      },
      (err) => {
        this.internalError("Ocorreu um erro ao tentar recuperar CDs de origem, tente novamente!");
      }
    );
  }

  onChangeSearch(descricao: string)
  {
    this.populaCdsOrigem(descricao);
  }

  ngOnInit(): void {
    //Limpa mensagem ao iniciar o componente
    this.alertService.limpaAlertMessage();
    
    this.preCheckoutQuery.cpf$.subscribe((cpf)=>{
      this.cpf = cpf;
    });

    this.preCheckoutQuery.name$.subscribe((nome)=>{
      this.nome = nome;
    });

    this.preCheckoutQuery.phone$.subscribe((celular)=>{
      this.celular = celular;
    });

    this.translate.get("preCheckout").subscribe((res) => {
      this.translation = res;
    });

    this.populaCdsOrigem();
  }

  internalError(err){
    this.alertService.alertDanger(err || this.translation.internalError, null);
  }
}